import React, { useContext } from 'react'
import { CarOrderingContext } from "../../CarOrdering";

export default function FooterInfo() {
  const {
    strings,
    textInFooter,
  } = useContext(CarOrderingContext)

  return (
    <div
      className='config-overview-bar__field config-overview-bar__field--delivery-text'
      dangerouslySetInnerHTML={{
        __html: typeof textInFooter === 'string' && textInFooter.length > 0 ? textInFooter : (strings.footer?.info ?? '')
    }}
    />
  )
}
